// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ia-6";
export var emphasizeQuantity = "_ia-3";
export var flatBottomCorners = "_ia-5";
export var productImage = "_ia-0";
export var quantityContainer = "_ia-2";
export var tooltip = "_ia-1";
export var wrapAndEllipsesOverflow = "_ia-4";